import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'

import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'

import {
  IAggregationAnalysisQuarter,
  IAggregationAnalysisSector,
  IResponseListApiDto,
  IResponseSortListApiDto,
} from '~/core/models'

const AGGREGATION_ANALYSIS_PREFIX = 'aggregation-analysis'

@Injectable({
  providedIn: 'any',
})
export class AggregationAnalysisApiService {
  constructor(private http: HttpClient) {}

  getAggregationAnalysisQuarterList(aggType: string): Observable<IAggregationAnalysisQuarter[]> {
    return this.http
      .get<IResponseListApiDto<IAggregationAnalysisQuarter>>(`${AGGREGATION_ANALYSIS_PREFIX}/quarter/list/${aggType}`)
      .pipe(map(res => res.data))
  }

  getAggregationAnalysisSectorList(
    aggType: string,
    year: number,
    quarter: number,
    sortBy: string,
    order: 'asc' | 'desc' | ''
  ): Observable<IAggregationAnalysisSector[]> {
    return this.http
      .get<
        IResponseSortListApiDto<IAggregationAnalysisSector>
      >(`${AGGREGATION_ANALYSIS_PREFIX}/sector/list/${aggType}/${year}/${quarter}?sortBy=${sortBy}&order=${order}`)
      .pipe(map(res => res.data))
  }
}
